/**
 * Bus de confirmación “agregado al carrito”.
 * Un solo listener global (MarketAddedToCartToaster) escucha este store.
 */

/** Toast no bloqueante: alcanza con unos segundos, antes eran 20s de modal. */
export const ADDED_TO_CART_DURATION_MS = 6_000;

export type AddedToCartPayload = {
  /** Nombre del producto / pack / combo */
  title: string;
  /** Slug de tienda — para armar link de checkout por defecto */
  storeSlug: string;
  imageUrl?: string | null;
  qty?: number;
  /**
   * Override del CTA Comprar:
   * - string → navegar a esa URL
   * - false → ocultar el botón Comprar
   * - omitido → `/checkout` del storefront
   */
  checkoutHref?: string | false;
};

type Listener = () => void;

let payload: AddedToCartPayload | null = null;
let buyHandler: (() => void) | null = null;
let generation = 0;
const listeners = new Set<Listener>();

function emit() {
  for (const l of listeners) l();
}

export function showAddedToCart(
  next: AddedToCartPayload & { onBuy?: () => void },
) {
  const title = next.title.trim();
  if (!title || !next.storeSlug.trim()) return;
  payload = {
    title,
    storeSlug: next.storeSlug.trim(),
    imageUrl: next.imageUrl ?? null,
    qty: next.qty && next.qty > 0 ? next.qty : 1,
    checkoutHref: next.checkoutHref,
  };
  buyHandler = next.onBuy ?? null;
  generation += 1;
  emit();
}

export function dismissAddedToCart() {
  if (!payload && !buyHandler) return;
  payload = null;
  buyHandler = null;
  generation += 1;
  emit();
}

export function runAddedToCartBuy(): boolean {
  if (buyHandler) {
    const fn = buyHandler;
    dismissAddedToCart();
    fn();
    return true;
  }
  return false;
}

export function getAddedToCartSnapshot(): AddedToCartPayload | null {
  return payload;
}

export function getAddedToCartGeneration(): number {
  return generation;
}

export function subscribeAddedToCart(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
